import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { sent } from "@api/notifications/sent/path";
import { markAsRead } from "@api/notifications/markAsRead/path";

const pathBase = `/notifications/`;
const pathById = `${pathBase}:notificationId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const notifications = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  sent,
  markAsRead,
} as const;
